// Adapted from ds/src/app/layouts/Sideblock/Sidebar/Header.tsx
// Uses inline HalfNote logo instead of SVG asset imports.
import { Link } from 'react-router';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';

import { Button } from '@lib/ui';
import { useSidebarContext } from '@/ds/contexts/sidebar/context';

function HalfNoteLogo() {
  return (
    <div className="flex items-center gap-2.5">
      <div className="flex size-8 items-center justify-center rounded-lg bg-primary-600">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="white"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
          />
        </svg>
      </div>
      <span className="text-lg font-semibold text-gray-900 dark:text-white">HalfNote</span>
    </div>
  );
}

export function Header() {
  const { close } = useSidebarContext();
  return (
    <header className="relative flex h-[61px] shrink-0 items-center justify-between ltr:pr-3 ltr:pl-6 rtl:pr-6 rtl:pl-3">
      <div className="flex items-center justify-start gap-4 pt-3">
        <Link to="/">
          <HalfNoteLogo />
        </Link>
      </div>
      <div className="pt-5 xl:hidden">
        <Button onClick={close} variant="flat" isIcon className="size-6 rounded-full">
          <ChevronLeftIcon className="size-5 rtl:rotate-180" />
        </Button>
      </div>
    </header>
  );
}
